import { render, staticRenderFns } from "./FiltersDashboard.vue?vue&type=template&id=079f6c22&"
import script from "./FiltersDashboard.vue?vue&type=script&lang=js&"
export * from "./FiltersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FiltersDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079f6c22')) {
      api.createRecord('079f6c22', component.options)
    } else {
      api.reload('079f6c22', component.options)
    }
    module.hot.accept("./FiltersDashboard.vue?vue&type=template&id=079f6c22&", function () {
      api.rerender('079f6c22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/dashboard/filters/FiltersDashboard.vue"
export default component.exports